import React from 'react';
import Loadable from 'Jsx/Shared/Loadable';

import { PhoneState as _PhoneState } from './types';
import usePhoneNumberState from './hooks/usePhoneNumberState';

const LazyPhoneInput = props => (
  <Loadable
    module={() =>
      import(
        /* webpackChunkName: "shared-react-phone-input" */
        /* webpackPrefetch: true */
        './PhoneInput'
      )
    }
    Loader={<div className="w-full h-56 mb-24 bg-gray-dark-16" />}
    {...props}
  />
);

export { usePhoneNumberState };

export type PhoneState = _PhoneState;

export default LazyPhoneInput;
